import { render, staticRenderFns } from "./client-edit.vue?vue&type=template&id=13e50ae5&scoped=true"
import script from "./client-edit.vue?vue&type=script&lang=js"
export * from "./client-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e50ae5",
  null
  
)

export default component.exports